import Peu from './Peu';
import PeuAmp from './PeuAmp';

export default function Component(props) {
    const { isAmp } = props;
    return isAmp ? <PeuAmp {...props} /> : <Peu {...props} />;
}
